import $ from 'jquery';

import FavoriteProductView from 'chairisher/view/product/favorite';
import FolderCardMenu, { FolderCardTransitionAnimations } from 'chairisher/component/card/foldercardmenu';
import ModalFactory from 'chairisher/factory/modal';
import ProductModel from 'chairisher/model/product';
import TooltipHelper from 'chairisher/view/helper/tooltip';

import bindAddToCart from 'chairisher/view/product/addtocart';
import getTradeInsuranceProgramBenefits from 'chairisher/context/trade';

import { trackSampleModalDisplay } from 'chairisher/analytics/product/detail';
import { trackAddToCart } from 'chairisher/analytics/cart';
import { FolderCardPosition, PDPSection } from 'chairisher/util/analytics';
import { handleAsyncError } from 'chairisher/util/logging';
import { fetchProduct } from 'chairisher/util/productdata';
import { getDataForVariantId } from 'chairisher/context/product';

class SampleDetailModal {
    constructor() {
        this.$openBtn = $('.js-sample-buy-button');
    }

    initialize() {
        if (this.$openBtn.length) {
            this.createModal();
            this.bindActions();
        }
    }

    createModal() {
        this.$sampleOrderModal = ModalFactory.createModal('js-sample-buy-modal', ModalFactory.ModalSize.SMALL);
        const $modalTitle = $('<h2></h2>', {
            class: 'modal-title',
            text: 'sample',
        });
        this.$sampleOrderModal.find('.js-modal-header').append($modalTitle);
        const template = document.querySelector('.js-sample-buy-modal-content');
        this.$sampleOrderModal.find('.modal-body').append(template.content.cloneNode(true));
        this.$sampleOrderModal.addClass('sample-buy-modal');
        this.$sampleOrderModal.css('overflow-y', 'scroll');
        this.$sampleOrderModal.appendTo(document.body);
    }

    renderFavAndFolder(id, toggle = false) {
        if (this.folderCardMenu) {
            this.folderCardMenu.removeFolderTrigger();
        }
        if (toggle) {
            FavoriteProductView.setFavoriteTrackingLabel(PDPSection.SAMPLE_MODAL);
            FavoriteProductView.toggleProductId(id, true);
        }
        const isFav = FavoriteProductView.isProductIdFavorited(id);
        FavoriteProductView.drawButton(isFav, id);
        FavoriteProductView.toggleButtonText(isFav);
        if (isFav) {
            const $modalContent = $('.modal-content');
            this.folderCardMenu = new FolderCardMenu({
                productId: id,
                analyticsTrackingPosition: FolderCardPosition.SAMPLE_MODAL,
                animation: FolderCardTransitionAnimations.flip,
                closeOnInteract: false,
                $appendTo: $modalContent,
            });
            this.folderCardMenu.marshalFolderTrigger().insertAfter('.js-modal-favorite-action');
            this.folderCardMenu.bind();
        }
    }

    bindActions() {
        const id = parseInt(this.$sampleOrderModal.find('[name="id"]').val(), 10);
        const product = new ProductModel(getDataForVariantId(id));

        $('.tt').tooltip({
            placement: TooltipHelper.getPlacement,
            html: true,
            title: getTradeInsuranceProgramBenefits().join('<br/>'),
        });

        $('.js-modal-favorite-action').on('click', () => {
            this.renderFavAndFolder(id, true);
        });

        this.$openBtn.on('click', () => {
            this.$sampleOrderModal.modal('show');
            FavoriteProductView.updateFavoriteProductIds().then(() => {
                this.renderFavAndFolder(id);
            }, handleAsyncError);

            // Start observing when the modal is shown
            this.observeModalOpenState();
        });

        this.$sampleOrderModal.on('click', '.js-btn-done', (e) => {
            e.preventDefault();
            this.$sampleOrderModal.modal('hide');
        });

        // Amplitude tracking for the Sample Detail Modal
        this.$sampleOrderModal.on('shown.bs.modal', () => {
            trackSampleModalDisplay(product, 'open');
        });

        this.$sampleOrderModal.on('hidden.bs.modal', () => {
            // Stop observing when the modal is hidden
            this.stopObservingModalState();
            trackSampleModalDisplay(product, 'close');
        });

        //
        // Add to Cart Binding
        //
        bindAddToCart(this.$sampleOrderModal.find('.js-buy-now-form'), product, async () => {
            this.$sampleOrderModal.modal('hide');

            try {
                const productData = await fetchProduct(id);
                trackAddToCart(new ProductModel(productData), FolderCardPosition.SAMPLE_MODAL);
            } catch (error) {
                handleAsyncError(error);
            }
        });
    }

    // Ensures the `modal-open` class is present on the <html> tag while the `#js-sample-buy-modal` is open.
    // This is for the scenario when the `#js-chairish-authentication-modal` appears above it (e.g., after clicking "favorites"),
    // to prevent background scrolling and re-add the `modal-open` class if removed (e.g., when closing auth modal).
    observeModalOpenState() {
        this.modalObserver = new MutationObserver(() => {
            if (this.$sampleOrderModal.hasClass('in') && !$('html').hasClass('modal-open')) {
                $('html').addClass('modal-open');
            }
        });
        this.modalObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }

    stopObservingModalState() {
        if (this.modalObserver) {
            this.modalObserver.disconnect();
            this.modalObserver = null;
        }
    }
}

export default SampleDetailModal;
